import { localizedStrings } from '@core/strings'
import {
  SelectFilterInternalArguments,
  SelectFilterValue,
  useSelectFilter,
} from './fundamentals'
import { FilterHookArgumentsBase } from '@core/providers/filters'
import { useGetRegisters } from '@core/react-query/features/registers/registers/hooks/useGetRegisters'

type RegistersFilterHookArgs<Multiple extends boolean | undefined> =
  FilterHookArgumentsBase<SelectFilterValue<number, Multiple>> & {
    organisationId: number
    projectIds?: number[]
    multiple?: Multiple
    nothingSelectedText?: string
  }

export const useRegistersFilter: <Multiple extends boolean | undefined>(
  arg: RegistersFilterHookArgs<Multiple>,
) => SelectFilterInternalArguments<number, Multiple> = ({
  organisationId,
  projectIds,
  nothingSelectedText = localizedStrings.allRegisters,
  ...args
}) => {
  const { data } = useGetRegisters({
    organisationId,
    projectIds,
    size: 10000,
  })

  const registers = data?.pages?.[0]?.content

  return useSelectFilter({
    ...args,
    options: registers?.map((register) => register.id) || [],
    valueToLabel: (id) =>
      registers?.find((register) => register.id === id)?.name,
    nothingSelectedText,
  })
}
